<template>
  <div class="cbox" style="margin: 0 auto">
    <el-form :model="userForm" :rules="rules" ref="userForm" label-width="120px" class="demo-ruleForm my user" style="width: 26.75rem;
    margin: 0 auto;">
      <el-form-item label="所属法人公司：" prop="corpname" class="rmsg" style="">
        <el-select @change="selectchange1" filterable value-key="corpcode" v-model="userForm.corpname" clearable placeholder="请选择门店" style="width:100%;" auto-complete="off">
          <el-option v-for="item in corpList" :key="item.corpcode" :label="item.corpname" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属门店：" prop="storename" class="rmsg" style="">
        <el-select @change="selectchange2"filterable value-key="storecode" v-model="userForm.storename" clearable placeholder="请选择门店" style="width:100%;" auto-complete="off">
          <el-option v-for="item in storeList" :key="item.storecode" :label="item.storename" :value="item"></el-option>
        </el-select>
      </el-form-item>
     <!--   @click="clickStore" <el-form-item label="所属部门：" prop="storecode" class="rmsg">
        <el-input type="text" v-model="userForm.pk_dept" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属门店编号：" prop="storecode" class="rmsg">
        <el-input type="text" v-model="userForm.storecode" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属门店名称：" prop="storename" class="rmsg">
        <el-input type="text" v-model="userForm.storename" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="门店营业许可证：" class="rmsg">
        <el-input type="text" v-model="userForm.busilicense" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
      </el-form-item> -->
      <!--  <el-form-item label="邮箱：" prop="email" class="rmsg">
            <el-input type="text" v-model="userForm.email" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
        </el-form-item>  -->
      </el-form-item>
      <el-form-item label="用户编号：" prop="user_code" class="rmsg">
        <el-input type="text" v-model="userForm.user_code" @change="selectchange4" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
        <div class="el-form-item__error" v-show="usercodeFlag">{{userMsg}}</div>
      </el-form-item>
      <el-form-item label="用户名称：" prop="user_name" class="rmsg">
        <el-input type="text" v-model="userForm.user_name" @click="writename" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="输入密码：" prop="password" class="rmsg">
        <el-input type="password" v-model="userForm.password" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="checkPass" class="rmsg">
        <el-input type="password" v-model="userForm.checkPass" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
      </el-form-item>
     
       <el-form-item label="角色选择：" prop="role_name" class="rmsg" style="">
        <el-select @change="selectchange3" filterable value-key="storecode" v-model="userForm.role_name" clearable placeholder="请选择门店" style="width:100%;" auto-complete="off">
          <el-option v-for="item in User_Roles" :key="item.role_code" :label="item.role_name" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" class="fr" @click="submitForm('userForm')">确认提交</el-button>
        <el-button size="small" type="warning" class="fr" style="margin-right: 20px" @click="returnManage">取消新增</el-button>
      </el-form-item>
    </el-form>
    <!-- model end -->
    <div class="" v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
  </div>
</template>
<script>
import MessageModel from '../../components/MessageModel'
export default {
  data() {
    var validateCorpname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('法人公司不能为空'));
      } else {
        callback();
      }
    }; 
    var validateStorename = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('门店名称不能为空'));
      } else {
        callback();
      }
    }; 
    var validatCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户编号不能为空'));
        this.usercodeFlag = false;
      }else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户名不能为空'));
      } else {
        callback();
      }
    }; 
    var validateroleName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('角色不能为空'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码不能小于6位'));
      } else {
        if (this.userForm.checkPass !== '') {
          this.$refs.userForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.userForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }; 
    var validateRole = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.userForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      userMsg:'', 
      methodName:'', 
      utilpath: '',
      usercodeFlag:false,
      fullscreenLoading:false,
      userForm: {
        'corpcode': '',
        'corpname': '',
        'storecode': '',
        'storename': '',
        'storehouse_code': '',
        'storehouse_name': '',
        // 'busilicense':'',
        // 'email':'',
        'user_code': '',
        'user_name': '',
        'password': '',
        'checkPass': '',
        'role_code': '',
        'role_name': ''
      },
      corpList:[],
      storeList:[],
      store: {
        storecode: '', //门店编码
        storename: '' //门店名称
      },
      jueseclass: "",
      User_Roles: [],
      userInfo: {},
      rules: {
        corpname: [
          { required: true, trigger: 'blur', validator: validateCorpname}
        ], 
        storename: [
          { required: true, trigger: 'blur', validator: validateStorename }
        ],
        user_code: [
          { required: true, trigger: 'blur', validator: validatCode }
        ],
        user_name: [
          { required: true, trigger: 'blur', validator: validateName }
        ], 
        role_name: [
          { required: true, trigger: 'blur', validator: validateRole }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ],
         role_name: [
          { required: true, validator: validateroleName, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.utilpath = this.axios.defaults.baseURL;
    this.getCorpcode();
    this.init();
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
          //  console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='adduser'){ 
              this.fullscreenLoading = true;
            //  console.log("---参数！！！----"+JSON.stringify(this.userForm));  
              this.$http.post(this.utilpath + '/useradd',this.userForm, { emulateJSON: true,_timeout:600 }).then((res) => { 
                    if (res.data.status == '0') {
                      this.fullscreenLoading = false;
                      this.$message({
                        showClose: true,
                        message: '注册成功！',
                        type: 'success'
                      });
                      this.usercodeFlag =false;
                      this.$router.push({ path: '/ui/system/authority' });  
                    } else if(res.data.status == '9'){
                          this.$router.push({path:'/ui/login',query:{msg:9}});
                      } else {
                      this.fullscreenLoading = false;
                      this.msgShow = true;
                      this.modelFlag = true;
                      this.usercodeFlag = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                      this.userMsg =  res.data.message;
                     // console.log("打印msg"+this.userMsg);
                    };
                  }, (err) => {
                    this.usercodeFlag =false;
                    this.msgShow =false;
                    this.fullscreenLoading = false;
                    this.modelFlag = true;
                    this.methodName = 'message';
                    this.msg = '连接新增用户接口失败';
                    this.butflag =false;
                    this.butmsg='知道了';
                  });
              }
      }else{
        this.usercodeFlag =false;
        this.fullscreenLoading = false;
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    returnMsg2(flag) { 
      this.modelFlag = false; 
       if (flag) {
       // console.log("---进来了！！！----" + this.methodName);
        if (this.methodName == 'message') {

        } 
      }
    }, 
    getCorpcode(){
      //获取数据接口 
      this.$http.post(this.utilpath + '/selectCorpfrinfo', { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          var corp = res.data.resultList;
          this.corpList = [];
          for (var i = corp.length - 1; i > -1; i--) {
            this.corpList.push({ corpcode: corp[i].storecode, corpname: corp[i].storename });
          }
        //  console.log("打印公司法人" + JSON.stringify(this.corpList));
        } else if (res.data.status == '-1') {
          this.corpList = [];
        //  console.log("-----暂无数据！！！");
        } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.msgShow = true;
          this.modelFlag = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }

      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
        console.log(err);
      });
    },
    getstore() {
      //参数
      var param={
        storecode:this.userForm.corpcode,
      };
      //获取数据接口 
      this.$http.post(this.utilpath+'/selectCorpfrandmdinfo',param, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          var stores = res.data.resultList;
          this.storeList = [];
          for (var i = stores.length - 1; i > -1; i--) {
            this.storeList.push({ storename: stores[i].storename, storecode: stores[i].storecode });
          }
        //  console.log("打印货位" + JSON.stringify(this.storeList));
        } else if (res.data.status == '-1') {
          this.storeList = [];
         // console.log("-----暂无数据！！！");
        } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
          // this.$alert(res.data.message, '失败信息', {
          //   confirmButtonText: '确定'
          // }); 
        }

      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了';
        // this.$alert('连接获取门店信息接口失败', '失败信息', {
        //   confirmButtonText: '确定'
        // });
       // console.log(err);
      });
    },
    selectchange1(value) {
      this.userForm.corpcode = value.corpcode;
      this.userForm.corpname = value.corpname;   
      this.getstore();
    },
    selectchange2(value) {
        if(this.userForm.corpcode!=''||this.userForm.corpcode!=null){
           this.userForm.storecode = value.storecode;
           this.userForm.storename = value.storename;   
           this.userForm.user_name = value.storename;   
           this.selectreporstory(value.storecode);
        }else{
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '请先选择法人公司';
            this.butflag =false;
            this.butmsg='知道了';
        }
    },
    selectreporstory(storecode){
      var param={
        storecode:storecode,
      }
      //获取数据接口
      this.$http.post(this.utilpath + '/selectStoreshopmonthinfo', param,{ emulateJSON: true,_timeout:600 }).then((res) => {
       //  console.log("打印返回值："+JSON.stringify(res.data));
        if (res.data.status == '0') {  
              this.userForm.storehouse_code = res.data.resultList[0].repertorycode;
              this.userForm.storehouse_name = res.data.resultList[0].repertoryname; 
        }else if(res.data.status == '-1'){
          //  console.log("暂无数据");
        } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.User_Roles = [];
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
        }
        // console.log("获取的JSON数据"+JSON.stringify(res.result));       
      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了';
      //  console.log(err);
      });
    },
    selectchange3(value) {
      this.jueseclass = value.length > 2 ? "juese" : "";
    //  console.log("===+++++++++++++++" + JSON.stringify(value));
    //  console.log("===+++++++++++++++" + JSON.stringify(this.userForm)); 
      this.userForm.role_code = value.role_code;
      this.userForm.role_name = value.role_name; 
    },
    selectchange4() {
    //  console.log("11111111111111111111111111111");
        var param={
          userCode:this.userForm.user_code,
        };
        this.$http.post(this.utilpath + '/checkUser',param, { emulateJSON: true,_timeout:600 }).then((res) => { 
       //   console.log("打印结果："+JSON.stringify(res.data));
          if (res.data.status == '-1') {
            this.usercodeFlag = true;
            // this.modelFlag2 = true;
            // this.methodName = 'message';
            this.userMsg = res.data.message;
          //  console.log("打印msg"+this.userMsg);
            // this.butflag2 =false;
            // this.butmsg2='知道了';
            // this.userForm.user_code = '';
          }else if(res.data.status == '0'){
            this.usercodeFlag = false;

          } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } 
          // console.log("获取的JSON数据"+JSON.stringify(res.result));       
        }, (err) => {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '连接查询总部是否存在该用户接口失败';
          this.butflag =false;
          this.butmsg='知道了';
          console.log(err);
        });
    },
    writename(){
        if(this.userForm.user_code==''||this.userForm.user_code==null){
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '请先输入用户编码检测总部是否存在该用户';
            this.butflag =false;
            this.butmsg='知道了';
        }
    },
    returnManage() {
      this.$router.push({ path: '/ui/system/authority' }); //跳转页面
    },
    getroles() {
      //获取数据接口 
      this.$http.post(this.utilpath + '/selectRole', { emulateJSON: true,_timeout:600 }).then((res) => { 
        if (res.data.status == '0') {
          var routers = res.data.resultList;
          for (var i = 0; i < routers.length; i++) {
            this.User_Roles.push({ role_name: routers[i].role_name, role_code: routers[i].role_code });
          }
        //  console.log("打印角色" + JSON.stringify(this.User_Roles));
        } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.User_Roles = [];
          this.modelFlag = true;
          this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了';
        }
        // console.log("获取的JSON数据"+JSON.stringify(res.result));       
      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接新增接口失败';
        this.butflag =false;
        this.butmsg='知道了';
        console.log(err);
      });
    },
    init() {
      this.getroles();
    }, 
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          
          this.methodName = 'adduser';
          this.modelFlag = true;
          this.msgShow =false;
          this.butflag = true;
          this.butmsg='确认';
          this.msg = '确定提交数据？'
          
        } else {
          this.$message({
            showClose: true,
            message: '填写信息不符合！',
            type: 'error'
          });
          return false;
        }
      });
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/AddUser.vue